import api from "../../baseurl";

const Create = async () => {
    const Create = await api.get("bonuses/showall").json(); 
    return Create.data ;
  };
  
  export default  Create ;